import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const Saved = () => {
  return <ObsIframe path="/tasklist/saved-task" />;
};

export default React.memo(Saved);
